export enum PluralLabelsEnum {
  ZERO = 0,
  SINGLE = 1,
  MULTI = 2,
}

export enum CommentsEnum {
  ZERO = 'Kommentarer',
  SINGLE = 'Kommentar',
  MULTI = 'Kommentarer',
}

export enum ReviewsEnum {
  ZERO = 'omdömen',
  SINGLE = 'omdöme',
  MULTI = 'omdömen',
}

export enum MottagningEnum {
  ZERO = 'mottagningar',
  SINGLE = 'mottagning',
  MULTI = 'mottagningar',
}
